import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import "./sendservice-style.scss";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal);

const moment = require("moment");

import { ListOfPdfs, SendService, SendServiceHistory } from "../api";
import { services } from "../constants";
import SendToServiceConfirmModal from "./modals/send-to-service-confirm/sendToServiceConfirm";
import ShowResponse from "./modals/show-send-to-service-response/show-response";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  expanded: { margin: 0 },
}));

export default function SendToService(props) {
  const classes = useStyles();

  const [alreadySubmitted, setAlreadySubmitted] = useState(false);
  const [submittedFilesHistory, setSubmittedFilesHistory] = useState([]);
  const [loader, setLoader] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showResponseModal, setShowResponseModal] = useState(false);
  const [selectedService, setService] = useState(null);
  const [combinedFiles, setCombinedFiles] = useState(
    props?.appData?.combined_files ? props?.appData?.combined_files : [],
  );

  useEffect(() => {
    serviceHistoryHandler();
  }, []);

  useEffect(() => {
    serviceHistoryHandler();
  }, [props.reRender]);

  const serviceHistoryHandler = () => {
    SendServiceHistory(props.appData.id)
      .then((res) => {
        setSubmittedFilesHistory(res.data);
        if (res.latest) {
          if (res.latest.status == 2) {
            setLoader(true);
          }
        }
      })
      .finally(() => { });
  };

  const toggleSendToServiceConfirmModal = () => {
    setShowConfirmModal(!showConfirmModal);
  };

  const onSubmitButtonClickHandler = (e, service) => {
    e.preventDefault();
    setService(service);
    toggleSendToServiceConfirmModal();
  };

  const onMainCheckBoxChangeHandler = (e, ser) => {
    if (!e.target.checked) {
      setService(null);
    } else {
      setService(ser);
    }
  };
  const onSendServiceHandler = (selectedFiles) => {
    setLoader(true);
    const data = {
      service: selectedService,
      id: props.appData.id,
      selectedFiles: selectedFiles || null
    };
    SendService(data)
      .then((res) => {
        if (res.status) {
          serviceHistoryHandler();
        } else {
          MySwal.fire({
            title: <p>{res.message}</p>,
            icon: "error",
            toast: true,
            position: "top-end",
            timer: 4000,
            timerProgressBar: true,
            showConfirmButton: false,
            customClass: "margin-top-sweetalert",
            didOpen: (toast) => {
              toast.addEventListener(
                "mouseenter",
                Swal.stopTimer,
              );
              toast.addEventListener(
                "mouseleave",
                Swal.resumeTimer,
              );
            },
          });
        }
      })
      .finally(() => {
        setLoader(false);
        setShowConfirmModal(false);
      });
  };

  const openAccordian = (service) => {
    if (selectedService != service) {
      setService(service);
    } else {
      setService(null);
    }
  };

  const toggleShowResponseModal = () => {
    setShowResponseModal(!showResponseModal);
  };

  const setServiceToState = (service) => {
    setService(service);
  };

  const renderList = (item) => {
    return item.map((item, i) => {
      return (
        <li key={i}>
          <div className="row">
            <div className="col-md-12 pdfupload">
              <input
                type="checkbox"
                checked={true}
                disabled={true}
              />
              <img src="/images/pdffile.svg" />
              {item}
            </div>
          </div>
        </li>
      );
    });
  };

  const Loader = () => {
    return <div class="bar_loader" title="Processing..."></div>;
  };

  const renderAccordion = (service) => {
    const submittedServices = submittedFilesHistory?.filter(
      (val) => val.service == service,
    );
    const submittedService = submittedServices
      ? submittedServices.pop()
      : null;
    const submittedDocuments = submittedService
      ? submittedService.documents
      : null;
    const submittedAddEndumHistory = submittedDocuments
      ? JSON.parse(submittedDocuments).addendums
      : [];
    const submittedMerchantDocs = submittedDocuments
      ? JSON.parse(submittedDocuments).docs
      : [];
    const created_at = submittedService
      ? moment(submittedService.created_at).format("YYYY-MM-DD")
      : null;
    const status = submittedService ? submittedService.status : null;
    const message = submittedService ? submittedService.message : null;
    const application_status = submittedService
      ? submittedService.application_status
      : null;
    const summary = () => (
      <AccordionSummary
        expandIcon={
          <ExpandMoreIcon onClick={() => openAccordian(service)} />
        }
        id={service}
      >
        <div
          className="row"
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          <div className="col-md-1">
            <input
              type="checkbox"
              checked={selectedService == service}
              disabled={alreadySubmitted}
              onChange={(e) =>
                onMainCheckBoxChangeHandler(e, service)
              }
            />
          </div>
          <div className="col-md-2">
            <h5 className="service-name">
              {service.toUpperCase()}
            </h5>
          </div>
          <div className="col-md-2">
            <b> API Status </b>
            <br />
            {status != null
              ? status == 1
                ? "Sent"
                : status == 2
                  ? "Pending"
                  : "Failed"
              : null}
          </div>
          <div className="col-md-2">
            <b>Application Status</b>
            <br />
            {application_status}
          </div>
          <div className="col-md-2">
            <b> Date Submitted </b>
            <br />
            {created_at}
          </div>
          <div className="col-md-3">
            <div className="row">
              <div className="col-md-6">
                {status == 2 ? (
                  <Loader />
                ) : (
                  <button
                    disabled={
                      loader ||
                      (submittedService && status == 1) ||
                      alreadySubmitted
                    }
                    className={`btn ${alreadySubmitted ? "" : "btn-primary"} btn-sm font10`}
                    onClick={(e) =>
                      onSubmitButtonClickHandler(
                        e,
                        service,
                      )
                    }
                  >
                    Submit
                  </button>
                )}
              </div>
              <div className="col-md-6">
                {alreadySubmitted != null &&
                  submittedService && (
                    <button
                      className="btn btn-sm font10"
                      onClick={(e) => {
                        setServiceToState(service);
                        setShowResponseModal(
                          !showResponseModal,
                        );
                      }}
                    >
                      Res.
                    </button>
                  )}
              </div>
            </div>
          </div>
        </div>
      </AccordionSummary>
    );
    const details = () => (
      <AccordionDetails>
        <div className="container" style={{ fontSize: "10px" }}>
          <div className="row" style={{ width: "100%" }}>
            <div className="">
              {eval(status) == 0 ? (
                <div className="row">
                  <div className="col-md-3">
                    <b>Message :</b>
                  </div>
                  <div className="col-md-9">
                    <p className="text-danger">
                      * {message}
                    </p>
                  </div>
                  <br />
                </div>
              ) : null}
            </div>
          </div>
          <br />
        </div>
      </AccordionDetails>
    );
    return { summary: summary(), details: details() };
  };
  let servicesEnabled = [];
  if (props?.appData?.organization?.bank_applications) {
    props?.appData?.organization?.bank_applications?.map(value => {
      if (value?.label == 'EMS Direct') {
        servicesEnabled.push('ems');
      } else {
        if (services.includes(value?.label.toLowerCase())) {
          servicesEnabled.push(value?.label.toLowerCase());
        }  
      }
    })
  } 
  return (
    <div className={classes.root}>
      <SendToServiceConfirmModal
        onCloseButtonClickHandler={toggleSendToServiceConfirmModal}
        onSubmitClickHandler={onSendServiceHandler}
        show={showConfirmModal}
        appData={props.appData}
        service={selectedService} 
        show_spinner={loader}
      />

      <ShowResponse
        show={showResponseModal}
        onClose={toggleShowResponseModal}
        service={selectedService}
        submittedFilesHistory={submittedFilesHistory}
      />

      {typeof alreadySubmitted == "boolean" && !alreadySubmitted
        ? servicesEnabled.map((service) => {

          const submittedServices = submittedFilesHistory?.filter(
            (val) => val.service == service,
          );
          const submittedService = submittedServices
            ? submittedServices?.pop()
            : null;
          const status = submittedService
            ? submittedService?.status
            : null;

          return (
            <Accordion
              className={`ems-auto-submit accordion-box ${submittedService ? (status == 1 ? "submitted" : status == 2 ? "processing" : "not-submitted") : ""}`}
              key={`sel-${service}`}
              expanded={service == selectedService}
            >
              {renderAccordion(service)["summary"]}
              {renderAccordion(service)["details"]}
            </Accordion>
          );
        })
        : null}

      {typeof alreadySubmitted == "boolean" && alreadySubmitted
        ? services.map((service) => {
          const submittedServices = submittedFilesHistory?.filter(
            (val) => val.service == service,
          );
          const submittedService = submittedServices
            ? submittedServices?.pop()
            : null;
          const status = submittedService
            ? submittedService.status == 1
            : null;
          if (status) {
            return (
              <Accordion
                className={`accordion-box a ${submittedService ? (status == 1 ? "submitted" : status == 2 ? "processing" : "not-submitted") : ""}`}
                key={`sel-${service}`}
              >
                {renderAccordion(service)["summary"]}
                {renderAccordion(service)["details"]}
              </Accordion>
            );
          } else {
            return (
              <Accordion
                expanded={false}
                className={`accordion-box b ${submittedService ? (status == 1 ? "submitted" : status == 2 ? "processing" : "not-submitted") : ""}`}
                key={`sel-${service}`}
              >
                {renderAccordion(service)["summary"]}
                <AccordionDetails />
              </Accordion>
            );
          }
        })
        : null}
    </div>
  );
}